import { httpClient } from '@/services/http/httpClient'

export type UpdateUserParams = {
  id: string
  email?: string
  name?: string
  area?: string
}

export async function updateUser({
  id,
  email,
  name,
  area,
}: UpdateUserParams): Promise<void> {
  await httpClient.put(`/users/${id}`, {
    email,
    name,
    areaId: area,
  })
}
